import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { useAuth } from "@contexts/auth";


export const useSignOut = () => {
  const handleErrors = useQueryErrorHandling();
  const navigate = useNavigate();
  const { resetAuthStates } = useAuth();
  let redirectURL = "";

  return useMutation({
    mutationFn: ({ redirectUrl }: { redirectUrl?: string }) => {
      redirectURL = redirectUrl ?? "";
      return api.post("logout");
    },
    onSuccess: () => {
      // console.log(res.data._id);
      resetAuthStates(); // Clear all auth state and React Query cache
      navigate("/", {
        replace: true,
        state: { redirectURL },
      });
    },

    onError: (res: any) => {
      console.error("[From Sign out]", res);

      handleErrors(res, "mutation");
    },
  });
};
